import { Breadcrumb, type BreadcrumbProps } from 'antd';
import { FC } from 'react';
import styles from './BreadCrumb.module.scss';

type TRenderLink = (url: string, text: string) => React.ReactElement;
type Props = {
  breadCrumb: number[];
  pageName: string;
  renderLink?: TRenderLink;
};

type BreadcrumbItem = {
  title: string;
  url: string;
};

type BreadcrumbConfig = {
  home: string;
  homeUrl: string;
  items: Record<number, BreadcrumbItem>;
};

// Hard-coded breadcrumb configurations from en.json
const breadcrumbConfigs: Record<string, BreadcrumbConfig> = {
  changelog: {
    home: 'Home',
    homeUrl: '/',
    items: {
      0: { title: 'More', url: '/' },
      1: { title: 'Changelog', url: '/' },
    },
  },
  pricing: {
    home: 'Home',
    homeUrl: '/',
    items: {
      0: { title: 'More', url: 'null' },
      1: { title: 'Pricing', url: 'null' },
    },
  },
};

const CustomLink: FC<{ url: string; text: string; renderLink?: TRenderLink }> = ({ url, text, renderLink }) => {
  if (renderLink) {
    return renderLink(url, text);
  }

  return <a href={url}>{text}</a>;
};

const BreadCrumb: FC<Props> = ({ pageName, breadCrumb, renderLink }) => {
  const config = breadcrumbConfigs[pageName] || {
    home: 'Home',
    homeUrl: '/',
    items: {},
  };

  const home = config.home;
  const url = config.homeUrl;

  const items: BreadcrumbProps['items'] = [];

  if (home !== 'null') {
    items.push({
      title: <CustomLink url={url} text={home} renderLink={renderLink} />,
      className: styles.containerItem,
    });
  }

  breadCrumb.forEach((item) => {
    const itemConfig = config.items[item] || { title: 'Unknown', url: '/' };
    const itemTitle = itemConfig.title;
    const itemUrl = itemConfig.url;

    items.push({
      title: itemUrl !== 'null' ? <CustomLink url={itemUrl} text={itemTitle} renderLink={renderLink} /> : itemTitle,
      className: styles.containerItem,
    });
  });

  return <Breadcrumb className={styles.container} items={items} />;
};

export { BreadCrumb };
